import { useDispatch, useSelector } from 'react-redux';
import LeafletSelectors, * as LeafletActions from 'redux/Leaflet';

const useLeaflet = () => {
  const dispatch = useDispatch();
  const position = useSelector(LeafletSelectors.getLeafletPosition);
  const baseLayer = useSelector(LeafletSelectors.getBaseLayer);
  const dataLayer = useSelector(LeafletSelectors.getDataLayer);
  const zoom = useSelector(LeafletSelectors.getZoom);
  const opacity = useSelector(LeafletSelectors.getOpacity);
  const dataLayerConfig = useSelector(LeafletSelectors.getDataLayerConfig);
  const mapDate = useSelector(LeafletSelectors.getMapDate);

  const updatePosition = (p) => {
    dispatch(LeafletActions.setLeafletPosition(p));
  };
  const setBaseLayer = (layer) => {
    dispatch(LeafletActions.setBaseLayer(layer));
  };
  const setDataLayer = (layer) => {
    dispatch(LeafletActions.setDataLayer(layer));
  };
  const setZoom = (level) => {
    dispatch(LeafletActions.setZoom(level));
  };
  const setOpacity = (o) => {
    dispatch(LeafletActions.setOpacity(o));
  };
  const setMapDate = (d) => {
    dispatch(LeafletActions.setMapDate(d));
  };

  return {
    position,
    baseLayer,
    dataLayer,
    dataLayerConfig,
    zoom,
    opacity,
    updatePosition,
    setBaseLayer,
    setDataLayer,
    setZoom,
    setOpacity,
    mapDate,
    setMapDate,
  };
};

export default useLeaflet;
